var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.965,
    height: 15.857,
    viewBox: "0 0 5.965 15.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expand",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M262.548,20.067a.5.5,0,1,0,1,0V15.722l1.3,1.3a.506.506,0,0,0,.719,0,.452.452,0,0,0,.149-.352.522.522,0,0,0-.149-.352L263.4,14.149a.452.452,0,0,0-.352-.149.49.49,0,0,0-.352.149l-2.172,2.172a.509.509,0,0,0,.719.719l1.3-1.3v4.33Z",
    transform: "translate(-260.059 -14)",
    fill: "#1d1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M249.8,263.7a.5.5,0,0,0,.5.5h4.962a.5.5,0,1,0,0-1h-4.948a.506.506,0,0,0-.516.5Z",
    transform: "translate(-249.8 -255.764)",
    fill: "#1d1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M262.7,332.3a.452.452,0,0,0,.352.149.49.49,0,0,0,.352-.149l2.172-2.172a.452.452,0,0,0,.149-.352.522.522,0,0,0-.149-.352.506.506,0,0,0-.719,0l-1.3,1.3V326.4a.5.5,0,0,0-1,0v4.327l-1.3-1.3a.509.509,0,1,0-.719.719Z",
    transform: "translate(-260.059 -316.593)",
    fill: "#1d1f24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.4374990ee6d1fbb2a5e5bfd499a77d29.svg";
export { ForwardRef as ReactComponent };